<template>
  <div class="p-inputtext-sm root-div">
    <message-container />
    <loading v-if="authenticating && !systemEnabled" />
    <template v-else>
      <div v-if="!!user" class="main-container">
        <top-nav />
        <div class="container-with-menu-over">
          <div>
            <div class="p-d-flex p-flex-md-row p-jc-center">
              <div v-if="systemEnabled" class="view-container">
                <router-view />
              </div>
              <loading v-else applyCustomLoading />
            </div>
          </div>
        </div>
      </div>
      <div v-else class="unsigned-screen">
        <div class="bg bg-morning" />
        <router-view class="content" />
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { systemEnabled } from "./modules/api";
import { setLanguage } from "./modules/utils";
import { useAuth } from "./modules/auth";
import { usePrimeVue } from "primevue/config";

import TopNav from "./components/layout/TopNav.vue";

export default defineComponent({
  components: { TopNav },
  setup() {
    const { authenticating, user } = useAuth();
    setLanguage(navigator.language, usePrimeVue().config.locale);
    return { systemEnabled, authenticating, user };
  }
});
</script>
<style lang="scss">
/* All global styles are now in src/scss/main.scss */
/* This file only contains App-specific scoped overrides if needed */
</style>
